module.exports = __webpack_public_path__ + "img/img-bi@3x.082ade92.png";